document.addEventListener('DOMContentLoaded', function() {
    console.log('Page loaded');

    if (window.location.href.includes('https://admin.shopify.com')) {
        return; // Stop execution of the script
    }

    // aby sa nespustalo v editore temy
    if (self.Shopify && !0 === self.Shopify.designMode){
      return;
    }


    // Helper functions for handling sessionStorage
    function getStoredPreference(key) {
        return sessionStorage.getItem(key);
    }

    function setStoredPreference(key, value) {
        sessionStorage.setItem(key, value);
    }

    // Clear stored preferences if requested via URL parameter
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('resetPrefs') === 'true') {
        console.log('Preferences reset.');
        sessionStorage.clear(); // Clear all sessionStorage entries
    }

    // Define country to locale mapping
    const countryToLocaleMap = {
        'gb': 'en',
        'us': 'en',
        'sk': 'sk',
        'hu': 'hu',
        'cz': 'cs', // Extend mappings as necessary
    };


      console.log('path: ' + window.location.pathname);
      // Check if automatic adjustments have already been applied to avoid a loop
      const hasAutoAdjusted = getStoredPreference('hasAutoAdjusted') === 'true';
      if (!hasAutoAdjusted) {
          const pendingLocaleUpdate = getStoredPreference('pendingLocaleUpdate');
          if (pendingLocaleUpdate && window.location.pathname === '/') {
              updateLocaleForCountry(pendingLocaleUpdate);
              sessionStorage.removeItem('pendingLocaleUpdate'); // Clear the flag after updating
          }
      }
  
      // Function to update locale based on the country
      function updateLocaleForCountry(countryCode) {
          const localeCode = countryToLocaleMap[countryCode];
          if (localeCode) {
              document.querySelectorAll('button[name="locale_code"]').forEach(button => {
                  if (button.value === localeCode) {
                      button.click(); // Change the locale
                      setStoredPreference('userLocalePreference', localeCode);
                      setStoredPreference('hasAutoAdjusted', 'true');
                  }
              });
          }
      }

  if(Shopify.country == 'SK' && Shopify.locale != 'sk' ){
    updateLocaleForCountry('sk');
  }

  if(Shopify.country == 'CZ' && Shopify.locale != 'cs' ){
    updateLocaleForCountry('cz');
  }

  if(Shopify.country == 'HU' && Shopify.locale != 'hu' ){
    updateLocaleForCountry('hu');
  }

    

    // Manual country change listener
    document.querySelectorAll('button[name="country_code"]').forEach(button => {
        button.addEventListener('click', () => {
            const selectedCountryCode = button.value.toLowerCase();
            console.log('Country code selected:', selectedCountryCode);
            setStoredPreference('userCountryPreference', selectedCountryCode);
            updateLocaleForCountry(selectedCountryCode); // Automatically update locale to match country
            setStoredPreference('pendingLocaleUpdate', selectedCountryCode); // Flag to indicate pending locale update
            sessionStorage.setItem('navigatedInternally', 'true'); // Set flag on internal navigation
        });
    });

    // If stored country does not match Shopify's country, update based on stored preference
    const storedCountry = getStoredPreference('userCountryPreference');
    console.log('Stored country:', storedCountry);
    if (storedCountry && storedCountry !== Shopify.country.toLowerCase() && window.location.pathname === '/') {
        document.querySelectorAll('button[name="country_code"]').forEach(button => {
            if (button.value.toLowerCase() === storedCountry) {
                button.click(); // Change the country based on stored preference
            }
        });
    } else if (!storedCountry && window.location.pathname === '/') { // If no country is stored, fetch IP info to set default
        fetch('https://ipinfo.io?token=124b72c5aa21b9')
            .then(response => response.json())
            .then(data => {
                const ipCountryCode = data.country.toLowerCase();
                console.log('IP Country Code:', ipCountryCode);
                if (ipCountryCode in countryToLocaleMap) {
                    document.querySelectorAll('button[name="country_code"]').forEach(button => {
                        if (button.value.toLowerCase() === ipCountryCode) {
                            button.click(); // Change the country
                            setStoredPreference('userCountryPreference', ipCountryCode);
                            updateLocaleForCountry(ipCountryCode);
                        }
                    });
                }
            })
            .catch(error => console.error('Error fetching IP info:', error));
    }

  
   
    function isBlogPage() {
        return window.location.pathname.includes('/blogs/');
    }

    // Function to check if the current page contains 'blogs/news' or 'blogs/blog'
    function checkBlogUrlSegment(segment) {
        const currentUrl = window.location.href; // Get the full URL
        return currentUrl.includes(segment); // Check if the URL contains the specified segment
    }
    
    // Function to replace URL segment based on country and redirect
    function replaceUrlSegmentAndRedirect() {
      const currentCountry = Shopify.country.toLowerCase(); // Ensure country code is in lower case
      const currentUrl = window.location.href;
      let newUrl = currentUrl;
  
      if (currentCountry !== 'gb' && checkBlogUrlSegment('/blogs/news')) {
          // Non-GB users - switch 'blogs/news' to 'blogs/blog'
          newUrl = currentUrl.replace('/blogs/news', '/blogs/blog');
      } else if (currentCountry === 'gb' && checkBlogUrlSegment('/blogs/blog')) {
          // GB users - switch 'blogs/blog' to 'blogs/news'
          newUrl = currentUrl.replace('/blogs/blog', '/blogs/news');
        console.log(newUrl);
      }
  
      // Redirect only if the URL has changed
      if (newUrl !== currentUrl) {
          window.location.href = newUrl;
      }
    }

  // Call the function to check and possibly replace the URL segment
  replaceUrlSegmentAndRedirect();

  console.log(isBlogPage());

  
});
